import { Data2, newId, dateToString } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { Currency } from '../../../tables/types/types'
import { DeliveryData, DeliveryStatus } from '../../deliveries'
import { Item, PaymentStatus } from '../../operations'
import { useSystemStateHooks } from '../../system'
import { PurchaseOrder } from '../state/types'

export const usePurchaseBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildPurchase = (data: Data2) => {
        const {
            id = newId(),
            code,
            items,
            creationDate,
            deliveryBranchId,
            supplierId,
            employeeId,
            deliveryData,
            deliveryStatus,
            paymentStatus,
            archived
        } = data

        const purchase: PurchaseOrder = {
            companyId: companyId!,
            id: id! as string,
            code: code! as number,
            items: (items || []) as Item[],
            currency: Currency.ARS,
            creationDate: dateToString(creationDate || new Date())!,
            deliveryBranchId: deliveryBranchId! as string,
            supplierId: supplierId! as string,
            employeeId: employeeId! as string,
            deliveryData: deliveryData as O<DeliveryData>,
            deliveryStatus: (deliveryStatus || DeliveryStatus.PENDING) as DeliveryStatus,
            paymentStatus: (paymentStatus || PaymentStatus.PENDING) as PaymentStatus,
            archived: !!archived
        }

        return purchase
    }

    return {
        buildPurchase
    }
}
